export const nukes = [
  {
    img: "https://i.imgur.com/s48I5SE.jpg",
    name: "Big Bertha",
    description: "Birth-a-destruction with this Big Bertha bomb.",
    price: 99999,
  },
  {
    img: "https://i.imgur.com/clr8EC0.jpg",
    name: "Truman's Timebomb",
    description:
      "Inspired by the presidential first domino that started it all!",
    price: 99,
  },
  {
    img: "https://i.imgur.com/QD1YJFE.jpg",
    name: "The Guardian",
    description:
      "Sponsored by The Guardian to destroy critics of journalism and media.",
    price: 9999,
  },
  {
    img: "https://i.imgur.com/Ck9tVQi.jpg",
    name: "The Double Tap",
    description:
      "If the first drop didn't work, The Double Tap will get the job done.",
    price: 320099,
  },
  {
    img: "https://i.imgur.com/fH4KQTZ.jpg",
    name: "Crash Dummy",
    description: "Crash head first into the enemy!",
    price: 650000,
  },
  {
    img: "https://i.imgur.com/DdZksPp.jpg",
    name: "Red Rocket",
    description:
      "Penetrate your way into the enemies' defenses with the Red Rocket.",
    price: 100000,
  },
  {
    img: "https://i.imgur.com/dLZFXJs.jpg",
    name: "The Elder",
    description: "The Elder is the premiere, experienced product.",
    price: 899999,
  },
  {
    img: "https://i.imgur.com/CVQrzMj.jpg",
    name: "Fat Man",
    description:
      "The infamous Fat Man reissue. Purchase while supplies still last.",
    price: 750000,
  },
];
